export const splittedDataToSortedArray = <T>(learningYearData: Record<string, T>) =>
  Object.entries(learningYearData).sort(([firstAcademicYear], [secondAcademicYear]) =>
    secondAcademicYear.localeCompare(firstAcademicYear),
  );
